export const environment = {
    env: 'Development',
    apiUrl: window['env']['DOMAINUAPI_URL'] || 'default',
    debug: window['env']['NODE_ENV'] || false,
    azureInsightsApiKey: window['env']['APPINSIGHTS_INSTRUMENTATIONKEY'] || '',
    ssoMsClientId: window['env']['SSO_MS_CLIENT_ID'] || '',
    ssoMsTenantId: window['env']['SSO_MS_TENANT_ID'] || ''
  };